module.exports = __webpack_public_path__ + "static/media/纺织大学_x264.755911d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/纺织大学_x264.mp4
// module id = PE6y
// module chunks = 13